// Popover amélioré : positionnement "fixed", placements et flip, fermeture hors clic.

(function () {
    const GAP = 8; // espace entre bouton et popover

    function place(btn, pop, placement = 'bottom-start') {
        const r = btn.getBoundingClientRect();
        const vw = window.innerWidth, vh = window.innerHeight;

        // mesurer le popover (le rendre visible hors-écran le temps du calcul)
        pop.style.left = '-9999px';
        pop.style.top = '-9999px';
        pop.classList.add('is-open');
        const pw = pop.offsetWidth, ph = pop.offsetHeight;
        pop.classList.remove('is-open');

        function compute(pos) {
            let left, top;
            switch (pos) {
                case 'bottom':       left = r.left + (r.width - pw) / 2; top = r.bottom + GAP; break;
                case 'bottom-end':   left = r.right - pw;                top = r.bottom + GAP; break;
                case 'bottom-start': left = r.left;                      top = r.bottom + GAP; break;
                case 'top':          left = r.left + (r.width - pw) / 2; top = r.top - ph - GAP; break;
                case 'top-end':      left = r.right - pw;                top = r.top - ph - GAP; break;
                case 'top-start':    left = r.left;                      top = r.top - ph - GAP; break;
                default:             left = r.left;                      top = r.bottom + GAP;
            }
            // clamp bordures
            left = Math.max(8, Math.min(left, vw - pw - 8));
            top  = Math.max(8, Math.min(top, vh - ph - 8));
            return { left, top };
        }

        // calc principal + flip si manque de place
        let pos = placement;
        let { left, top } = compute(pos);

        const needFlip = (pos.startsWith('bottom') && r.bottom + GAP + ph > vh) ||
            (pos.startsWith('top')    && r.top   - GAP - ph < 0);

        if (needFlip) {
            const flipped = pos.startsWith('bottom') ? pos.replace('bottom', 'top')
                : pos.replace('top', 'bottom');
            ({ left, top } = compute(flipped));
        }

        pop.style.left = `${Math.round(left + window.scrollX)}px`;
        pop.style.top  = `${Math.round(top  + window.scrollY)}px`;
    }

    function closeAll(except) {
        document.querySelectorAll('.popover.is-open').forEach(p => { if (p !== except) p.classList.remove('is-open'); });
        document.querySelectorAll('[data-popover][aria-expanded="true"]').forEach(b => b.setAttribute('aria-expanded','false'));
    }

    // Toggle open
    document.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-popover]');
        const isInsidePop = e.target.closest('.popover');

        if (btn) {
            const sel = btn.getAttribute('data-popover');
            const pop = document.querySelector(sel);
            if (!pop) return;

            const willOpen = !pop.classList.contains('is-open');
            closeAll(willOpen ? pop : null);

            if (willOpen) {
                const placement = btn.getAttribute('data-placement') || 'bottom-start';
                place(btn, pop, placement);
                pop.classList.add('is-open');
                btn.setAttribute('aria-expanded','true');
                pop.setAttribute('aria-hidden','false');
            } else {
                pop.classList.remove('is-open');
                btn.setAttribute('aria-expanded','false');
                pop.setAttribute('aria-hidden','true');
            }
            return;
        }

        // clic hors popover => fermer
        if (!isInsidePop) closeAll();
    });

    // ESC => fermer
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeAll();
    });

    // repositionner si on scroll/resize pendant qu’il est ouvert
    ['scroll','resize'].forEach(evt => {
        window.addEventListener(evt, () => {
            const open = document.querySelector('.popover.is-open');
            if (!open) return;
            // retrouver le bouton lié
            const btn = document.querySelector(`[data-popover="#${open.id}"][aria-expanded="true"]`);
            if (btn) {
                const placement = btn.getAttribute('data-placement') || 'bottom-start';
                place(btn, open, placement);
            }
        }, { passive: true });
    });
})();
